import { joinHouseNumber } from './getHouseNumber';

export interface AddressData {
  street?: string;
  houseNumber?: string;
  houseOrientationNumber?: string;
  zip?: string;
  city?: string;
}

/**
 * Formats an address object into a readable string
 * @param address - Address data object
 * @returns Formatted address string (e.g., "Main Street 123/4, 12000 Prague")
 */
export const formatAddress = (address?: AddressData): string => {
  if (!address) return '';

  const streetPart = address.street
    ? `${address.street} ${joinHouseNumber(address.houseNumber, address.houseOrientationNumber)}`.trim()
    : '';

  const cityPart =
    address.zip || address.city ? `${address.zip || ''} ${address.city || ''}`.trim() : '';

  return [streetPart, cityPart].filter(Boolean).join(', ');
};
